// extracted by mini-css-extract-plugin
export var action = "ComboGroup-module--action--1e58d";
export var boldLabel = "ComboGroup-module--boldLabel--d9fd3";
export var combo = "ComboGroup-module--combo--44a03";
export var exacta = "ComboGroup-module--exacta--28e2b";
export var exotic = "ComboGroup-module--exotic--6fbce";
export var first4 = "ComboGroup-module--first4--00039";
export var group = "ComboGroup-module--group--fb79e";
export var header = "ComboGroup-module--header--8b954";
export var label = "ComboGroup-module--label--4d5ca";
export var quaddie = "ComboGroup-module--quaddie--e7c93";
export var quinella = "ComboGroup-module--quinella--606ef";
export var selected = "ComboGroup-module--selected--1a49b";
export var sgm = "ComboGroup-module--sgm--08a57";
export var slot = "ComboGroup-module--slot--f5de7";
export var srm = "ComboGroup-module--srm--c5742";
export var tag = "ComboGroup-module--tag--62870";
export var trifecta = "ComboGroup-module--trifecta--e1780";